module.exports = __webpack_public_path__ + "static/img/storageFu1.ce76efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageFu1.png
// module id = MJcK
// module chunks = 2